import type { ReactNode } from 'react';

export const symbol_stylus_highlighter: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M311-326q-12.75 0-21.37-8.63Q281-343.25 281-356v-424q0-24.75 17.69-42.38Q316.38-840 341.22-840q6.78 0 13.36 1.5 6.57 1.5 12.42 4.5l277 134q16 8 25 22.47 9 14.47 9 31.53v290q0 12.75-8.62 21.37Q660.75-326 648-326H311Zm30-60h277v-259L341-779v393Zm0 0h277-277ZM203-120q-16 0-24.5-12.5T175-160l6-17q8-22 26.84-35.5T250-226h460q23.32 0 42.16 13.5Q771-199 779-177l6 17q5 15-3.5 27.5T757-120H203Z"
		/>
	</svg>
);
